// extracted by mini-css-extract-plugin
export var enableScrolling = "InfiniteScroll-module--enableScrolling--4c7f6";
export var group = "InfiniteScroll-module--group--4c6fe";
export var parent = "InfiniteScroll-module--parent--f85d2";
export var pauseOnHover = "InfiniteScroll-module--pauseOnHover--3469e";
export var reverse = "InfiniteScroll-module--reverse--4fc1b";
export var scrolling = "InfiniteScroll-module--scrolling--fea39";
export var track = "InfiniteScroll-module--track--68ba0";